import { useQueryTax } from '../../models/useQueryTax'

export const useTaxDataFieldPresenter = ({ id }: { id: number }) => {
  const { tax, isFetching } = useQueryTax(id)

  return {
    data: {
      tax,
    },
    states: {
      showLoader: isFetching,
    },
  }
}
